var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { p as pathHandle } from "./index-832b8870.js";
class JLocation {
  // 定义一个构造函数，用于初始化JLocation对象
  constructor(ops) {
    // 定义一个location属性，用于存储window.location对象的副本
    __publicField(this, "location");
    // 业务路径
    __publicField(this, "basePath");
    this.location = window.location;
    this.basePath = (ops == null ? void 0 : ops.basePath) || "";
  }
  pathFactory(uri) {
    return pathHandle(uri, this.basePath);
  }
  // 定义一个reload方法，用于重新加载当前页面
  reload() {
    this.location.reload();
  }
  // 定义一个replace方法，用于替换当前页面
  replace(url) {
    this.location.replace(this.pathFactory(url));
  }
  // 定义一个assign方法，用于加载新的页面
  assign(url) {
    this.location.assign(url);
  }
  // 定义一个toString方法，用于返回location对象的字符串表示
  toString() {
    return this.location.toString();
  }
  get baseOrigin() {
    return this.location.origin + this.basePath;
  }
  get origin() {
    return this.location.origin;
  }
  // 定义一个hash属性，用于存储或修改location对象的hash部分
  set hash(value) {
    this.location.hash = value;
  }
  get hash() {
    return this.location.hash;
  }
  // 定义一个href属性，用于存储或修改location对象的完整URL
  set href(value) {
    this.location.href = this.pathFactory(value);
  }
  get href() {
    return this.location.href;
  }
  // 定义一个protocol属性，用于存储或修改location对象的协议部分
  set protocol(value) {
    this.location.protocol = value;
  }
  get protocol() {
    return this.location.protocol;
  }
  // 定义一个host属性，用于存储或修改location对象的主机名和端口号部分
  set host(value) {
    this.location.host = value;
  }
  get host() {
    return this.location.host;
  }
  // 定义一个hostname属性，用于存储或修改location对象的主机名部分
  set hostname(value) {
    this.location.hostname = value;
  }
  get hostname() {
    return this.location.hostname;
  }
  // 定义一个port属性，用于存储或修改location对象的端口号部分
  set port(value) {
    this.location.port = value;
  }
  get port() {
    return this.location.port;
  }
  // 定义一个pathname属性，用于存储或修改location对象的路径名部分
  set pathname(value) {
    this.location.pathname = this.pathFactory(value);
  }
  get pathname() {
    return this.location.pathname;
  }
  // 定义一个search属性，用于存储或修改location对象的查询字符串部分
  set search(value) {
    this.location.search = value;
  }
  get search() {
    return this.location.search;
  }
}
class JoJoRouter extends JLocation {
  // debug: boolean = false
  basePathArrange() {
    var basePath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return basePath === "/" ? "" : basePath;
  }
  constructor(ops) {
    super(ops);
    this.basePath = this.basePathArrange((ops == null ? void 0 : ops.basePath) || "");
  }
  /**
   *  设置basePath
   * @param basePath basePath
   */
  setBasePath(basePath) {
    this.basePath = this.basePathArrange(basePath);
  }
  /* log(fun: string, val: string, ) {
    if (this.debug) {
      console.log(`业务路径：${this.basePath}；执行[${fun}]：${val}`) 
    }
  } */
  /**
   * 地址兼容多种部署形式
   * @param uri 地址：兼容path和url
   * @returns 构造后的地址
   */
  urlh(uri, basePath) {
    return pathHandle(uri, basePath || this.basePath);
  }
}
export { JoJoRouter as default };
